class AccordionItems extends HTMLElement {
  constructor() {
    super()

    this.faqItems = this.querySelectorAll('.accordion-item');
    this.isOnlyOneOpened = this.dataset.isOnlyOneOpened == 'true' ? true : false;
  }

  connectedCallback() {
    this.addEventListener('click', this.accordionClickHandle.bind(this))
  }

  accordionClickHandle(event) {
    if (event?.target.closest('.accordion-item__trigger')) {
      this.onQuestionClick(event?.target.closest('.accordion-item'));
    }
  }

  onQuestionClick(clickedItem) {
    if (this.isOnlyOneOpened) {
      this.faqItems.forEach(faqItem => {
        if (clickedItem !== faqItem) {
          faqItem.classList.remove('accordion-item--active')
        }
      })
    }

    clickedItem.classList.toggle('accordion-item--active');
  }
}

if (!customElements.get('accordion-items')) {
  customElements.define('accordion-items', AccordionItems);
}